import axios from 'axios'

export default {
    data() {
        return {
            dataset: [],
        }
    },
    methods:{
        async dataRegentes() {
    
            await axios
                .get(`/data/data_regentes.json`)
                .then(response => {                    
                    this.dataset = this.dataset.concat(response.data)                    
                })
        },
        async infoRegentes() {

            await axios
                .get(`/data/actualizado.json`)
                .then(response => {
                    this.dataset = this.dataset.concat(response.data)
                })
        }
    }
}